// eslint-disable-next-line
import {
	UserLayout,
	BlankLayout
} from '@/layouts'
import {
	bxAnaalyse
} from '@/core/icons'
/**
 * 这里不再保留原来默认的菜单asyncRouterMap
 * https://github.com/sendya/ant-design-pro-vue/blob/master/src/router/generator-routers.js
 */
export const defaultRouterMap = [{
		'title': '首页',
		'key': 'dashboard',
		'component': 'RouteView',
		'redirect': '/dashboard/weclome',
		'icon': 'smile',
		'children': [{
			// path: "/dashboard/weclome",
			'title': 'menu.dashboard.weclome',
			'key': 'weclome',
			'icon': '',
			// component: () => import( /* webpackChunkName: "dashboard" */ '@/views/dashboard/Welcome')
		}]
	},
	// {
	// 	path: '/dashboard',
	// 	name: 'dashboard',
	// 	redirect:'welcome',
	// 	component: () => import( /* webpackChunkName: "dashboard" */ '@/layouts/RouteView'),
	// 	children: [{
	// 		name: 'welcome',
	// 		path: 'welcome',
	// 		component: () => import( /* webpackChunkName: "dashboard" */ '@/views/dashboard/Welcome')
	// 	}]

	// },
	// 	{
	// 	'title': '首页',
	// 	'key': 'dashboard1',
	// 	'component': 'RouteView',
	// 	'redirect': '/dashboard/weclome',
	// 	'icon': bxAnaalyse,
	// 	'children': [{
	// 		'title': 'menu.dashboard.weclome',
	// 		'key': 'weclome',
	// 		'icon': ''
	// 	}, ]
	// },
]



/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [{
		path: '',
		name: 'myhome',
		// redirect: '/myhome',
		hidden: true,
		component: () => import( /* webpackChunkName: "user" */ '@/views/user/myhome')
		// children: [{
		// 	title: '添加更多快捷方式',
		// 	key: 'shortcuts',
		// 	icon: '',
		// 	path: "/dashboard/shortcuts",
		// 	component: () => import('@/views/dashboard/shortcuts')

		// }]
	},

	{
		path: '/user',
		name: 'user',
		component: UserLayout,
		redirect: '/user/Login',
		hidden: true,
		children: [{
				path: 'login',
				name: 'login',
				component: () => import( /* webpackChunkName: "user" */ '@/views/user/Login')
			},
			{
				path: 'register',
				name: 'register',
				component: () => import( /* webpackChunkName: "user" */ '@/views/user/Register')
			},
			
			{
				path: 'register-result',
				name: 'registerResult',
				component: () => import( /* webpackChunkName: "user" */ '@/views/user/RegisterResult')
			},
		]
	},
	{
		path: '/home',
		name: 'home',
		component: () => import( /* webpackChunkName: "user" */ '@/views/user/home')
	},
	{
		path: '/moreissue',
		name: 'moreissue',
		component: () => import( /* webpackChunkName: "user" */ '@/views/dashboard/moreissue')
	},
	{
		path: '/logs',
		name: 'logs',
		component: () => import( /* webpackChunkName: "user" */ '@/views/dashboard/logs')
	},
	{
		path: '/privacy',
		name: 'privacy',
		component: () => import( /* webpackChunkName: "user" */ '@/views/user/privacy')
	},
	{
		path: '/404',
		component: () => import( /* webpackChunkName: "fail" */ '@/views/exception/404')
	},

]
